module.exports = __webpack_public_path__ + "img/rrs_rorgametoken.20aad23.png";